import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
export const Toast = ({
  message
}) => {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white px-4 py-3 rounded-lg shadow-lg flex items-center z-50 animate-fade-in" data-id="element-201">
      <CheckCircleIcon size={18} className="mr-2 text-green-400" data-id="element-202" />
      <span data-id="element-203">{message}</span>
      <button onClick={() => setIsVisible(false)} className="ml-3 text-gray-300 hover:text-white" data-id="element-204">
        <XIcon size={16} data-id="element-205" />
      </button>
    </div>;
};